module.exports = __webpack_public_path__ + "img/coupon_nine.e12e9dee.webp";